<template>
	<a class="onSaleNowFirst" href="#dailysale" @click.prevent="scrollto()">
		<div class="title">限時瘋搶</div>
		<div class="main">
			<div class="pic"><img :src="item.image" :alt="item.name" class="d-block"></div>
			<div class="slogag">{{item.slogan}}</div>
			<div class="price">
				<small>${{item.price.origin}}</small> <strong><i>$</i>{{item.price.onsale}}</strong>
			</div>
		</div>
	</a>
</template>

<script>

export default {
    name: 'onSaleNowFirstTemplate',
	props: ['item'],
	methods: {
		scrollto() {
			//#dailysale
			const viewOnSaleAll = document.getElementById("flashdeal");
			viewOnSaleAll.scrollIntoView({ behavior: 'smooth' });
		}
	}
};
</script>

<style lang="scss" scoped>
.onSaleNowFirst {
	width: 100%;
	height: 100%;
	color: #f01b34;
	position: relative;
	padding: 8px;
	border-radius: 12px;
	background: #ffa7ad;
	.title, .slogag {
		text-align: center;
		position: relative;
		z-index: 1;
	}
	.title {
		font-size: 1.3rem;
		font-weight: 500;
		color: #fff;
		background-color: #8072ed;
		border-radius: 1.25rem 1.25rem 0 0;
		width: 85%;
		padding-left: 1rem;
		margin: 0 auto;
		border-right: 5px solid #5a4bc6;
		@media only screen and (max-width: 640px) {
			font-size: 1rem;
			width: 80%;
		}
		&::before {
			content: '';
			width: 2.5rem;
			height: 100%;
			background: url('@/assets/new/onsale_icon.png') bottom center no-repeat;
			background-size: 90%;
			position: absolute;
			left: 0.6rem;
			bottom: 0;
		}
	}
	.main {
		background-color: #fff;
		border-radius: 8px;
		padding: .3rem 0 7px;
	}
	.pic {
		width: 92%;
		margin: auto;
		transition: .3s all;
		@media only screen and (max-width: 991px) {
			width: 86%;
		}
		@media only screen and (max-width: 640px) {
			width: 85%;
		}
	}
	.slogag {
		width: 100%;
		color: #000;
		margin: 3px 0 5px;
		font-size: 1.05rem;
		font-weight: 500;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
		@media only screen and (max-width: 640px) {
			font-size: 15px;
		}
	}
	.price {
		text-align: center;
		font-family: Montserrat, "Noto Sans TC";
		line-height: 1;
		strong {
			font-size: 2.2rem;
			font-weight: 800;
			@media only screen and (max-width: 640px) {
				font-size: 26px;
			}
			i {
				font-weight: 600;
				font-size: 60%;
			}
		}
		small {
			color: #8e8e8e;
			font-size: 14px;
			font-weight: 400;
			text-decoration-line: line-through;
			@media only screen and (max-width: 640px) {
				font-size: 13px;
			}
			@media only screen and (max-width: 360px) {
				font-size: 11px;
			}
		}
	}
	&:hover .pic {
		filter: brightness(1.2);
		@media only screen and (max-width: 991px) {
			filter: none;
			transform: none;
		}
	}
}

</style>
